import type { AgendaCampaign } from './types';

const CACHE_KEY = 'fixe-admin:campaign-agenda:v1';
/** Cache local da varredura completa — 6 horas. */
export const AGENDA_CACHE_TTL_MS = 6 * 60 * 60 * 1000;

interface AgendaCachePayload {
  fetchedAt: number;
  campaigns: AgendaCampaign[];
}

/** Versão enxuta para não estourar localStorage (sem mensagem longa). */
export function toAgendaCacheRow(c: AgendaCampaign): AgendaCampaign {
  return {
    _id: c._id,
    name: c.name,
    active: c.active,
    tipo_disparo: c.tipo_disparo,
    frequencia: c.frequencia,
    frequencia_horas: c.frequencia_horas,
    frequencia_dia: c.frequencia_dia,
    frequencia_unico: c.frequencia_unico,
    frequencia_dia_semana: c.frequencia_dia_semana,
    expirar: c.expirar,
    dt_fim: c.dt_fim,
    created_at: c.created_at,
    id_passbook: c.id_passbook,
    clientId: c.clientId,
    clientName: c.clientName,
    passbookId: c.passbookId,
    passbookName: c.passbookName,
    backgroundColor: c.backgroundColor,
  };
}

export function readAgendaCache(): AgendaCachePayload | null {
  try {
    const raw = localStorage.getItem(CACHE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as AgendaCachePayload;
    if (!parsed?.fetchedAt || !Array.isArray(parsed.campaigns)) return null;
    if (Date.now() - parsed.fetchedAt > AGENDA_CACHE_TTL_MS) return null;
    return parsed;
  } catch {
    return null;
  }
}

export function writeAgendaCache(campaigns: AgendaCampaign[]): void {
  try {
    const payload: AgendaCachePayload = {
      fetchedAt: Date.now(),
      campaigns: campaigns.map(toAgendaCacheRow),
    };
    localStorage.setItem(CACHE_KEY, JSON.stringify(payload));
  } catch {
    // quota / private mode — agenda ainda funciona sem persistir
  }
}

export function clearAgendaCache(): void {
  try {
    localStorage.removeItem(CACHE_KEY);
  } catch {
    /* noop */
  }
}

export function agendaCacheAgeLabel(fetchedAt: number): string {
  const mins = Math.floor((Date.now() - fetchedAt) / 60_000);
  if (mins < 1) return 'agora';
  if (mins < 60) return `há ${mins} min`;
  const hours = Math.floor(mins / 60);
  return `há ${hours}h`;
}
